export const clone = <V>(value: V): V => {
  if (value instanceof Date) {
    return new Date(value.getTime()) as V
  } else if (value instanceof RegExp) {
    return new RegExp(value.source, value.flags) as V
  } else if (value instanceof Map) {
    const cloned = new Map()
    for (const [k, v] of value) {
      cloned.set(clone(k), clone(v))
    }
    return cloned as V
  } else if (value instanceof Set) {
    const cloned = new Set()
    for (const v of value) {
      cloned.add(clone(v))
    }
    return cloned as V
  } else if (value instanceof ArrayBuffer) {
    return value.slice(0) as V
  } else if (value instanceof Int8Array) {
    return new Int8Array(value) as V
  } else if (value instanceof Uint8Array) {
    return new Uint8Array(value) as V
  } else if (value instanceof Uint8ClampedArray) {
    return new Uint8ClampedArray(value) as V
  } else if (value instanceof Int16Array) {
    return new Int16Array(value) as V
  } else if (value instanceof Uint16Array) {
    return new Uint16Array(value) as V
  } else if (value instanceof Int32Array) {
    return new Int32Array(value) as V
  } else if (value instanceof Uint32Array) {
    return new Uint32Array(value) as V
  } else if (value instanceof Float32Array) {
    return new Float32Array(value) as V
  } else if (value instanceof Float64Array) {
    return new Float64Array(value) as V
  } else if (value instanceof BigInt64Array) {
    return new BigInt64Array(value) as V
  } else if (value instanceof BigUint64Array) {
    return new BigUint64Array(value) as V
  } else if (value instanceof DataView) {
    return new DataView(value.buffer.slice(0), value.byteOffset, value.byteLength) as V
  } else if (Array.isArray(value)) {
    return value.map((v) => clone(v)) as V
  } else if (value && typeof value === 'object') {
    const cloned = {} as V
    for (const key in value) {
      if (!Object.hasOwn(value, key)) continue
      cloned[key] = clone(value[key])
    }
    return cloned
  } else {
    return value
  }
}
